import { LuSearch, LuX } from "react-icons/lu";
import "./styles.css";
import { useIntl } from "react-intl";
import useTracker from "../../../hooks/useTracker";
import { useDispatch, useSelector } from "react-redux";
import { setSearch } from "../../../features/digitalIdentitiesSlice";
import CustomSelect from "../../CustomSelect";
import { useEffect, useState } from "react";
const Search = ({ filter, handleChange, handleSearch }) => {
  const intl = useIntl();
  const [placeholderSearch, setPlaceholderSearch] = useState();
  const dispatch = useDispatch();
  const { identitySearchTracker } = useTracker();
  const { types: searchSelectTypes } = useSelector((state) => state.types);

  const handleSearchOnEnter = (e) => {
    if (e.key === "Enter") {
      handleSearch({ ...filter });
    }
  };
  const handleClear = () => {
    handleChange({ ...(filter || {}), value: "" });
    handleSearch({});
    identitySearchTracker({});
  };
  const handleTypeChange = (e) => {
    handleChange({
      ...(filter || {}),
      type: e?.value,
    });
  };

  const handleValueChange = (e) => {
    dispatch(setSearch({ type: filter?.value, value: "" }));
    handleChange({
      ...(filter || {}),
      value: e.target.value,
    });
  };

  useEffect(() => {
    if (searchSelectTypes?.length && !filter?.type)
      handleTypeChange(searchSelectTypes[0]);
  }, [searchSelectTypes]);
  useEffect(() => {
    if (searchSelectTypes?.length && filter?.type)
      setPlaceholderSearch(
        searchSelectTypes?.find((type) => type?.value == filter.type)
      );
  }, [filter.type, searchSelectTypes]);

  return (
    <div className="search w-80">
      <div className="custom-select-search-container">
        <CustomSelect
          options={searchSelectTypes}
          defaultValue={filter?.type}
          value={filter?.type}
          onChange={handleTypeChange}
          variant="select-search"
        />
      </div>
      <div className="search-form">
        <input
          className="form-control rounded-3"
          type="text"
          placeholder={intl.formatMessage(
            {
              id: "id.search.placeholder",
              defaultMessage: "Search by {search}",
            },
            {
              search:
                placeholderSearch?.placeholder ||
                placeholderSearch?.label ||
                "",
            }
          )}
          aria-label="Search by Identity type"
          value={filter?.value}
          onChange={handleValueChange}
          onKeyUp={handleSearchOnEnter}
        />
        <div className="search-button">
          <button onClick={() => handleSearch({ ...filter })}>
            <LuSearch className="search-icon" size={25} />
          </button>
        </div>
        {filter?.value && (
          <div className="cross-button">
            <button onClick={handleClear}>
              <LuX className="cross-icon" size={25} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Search;
